<template>
  <div>
    <div :class="$style.field">
      <div :class="$style.field_label">
        {{ locales('export_setting_size') }}
      </div>
      <vgp-dropdown-select
        :drop-list="paperSizeOptions"
        :multiselect="false"
        :selected="form.selectedPaperSize"
        :show-reset-btn="false"
        track-by-text="label"
        :show-selected-first="false"
        @selected="handleSelectPaperSize"
      />
    </div>
    <div :class="$style.field">
      <div :class="$style.field_label">
        {{ locales('export_setting_orient') }}
      </div>
      <div :class="$style.radio_group">
        <vgp-radio-button
          :class="$style.radio_group_item"
          :checked="form.selectedOrientation === 'landscape'"
          :label="locales('export_setting_orient_landscape')"
          label-position="right"
          title-color="#191919"
          @update:checked="handleChangeOrientation('landscape')"
        />
        <vgp-radio-button
          :class="$style.radio_group_item"
          :checked="form.selectedOrientation === 'portrait'"
          :label="locales('export_setting_orient_portrait')"
          label-position="right"
          title-color="#191919"
          @update:checked="handleChangeOrientation('portrait')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import VgpDropdownSelect from '$$vueCmp/dropdownSelect/dropdownSelect.vue';
import VgpRadioButton from '$$vueCmp/radioButton/vgpRadioButton.vue';

export default {
  name: 'PdfSettings',
  components: {
    VgpDropdownSelect,
    VgpRadioButton,
  },
  props: {
    isMultiview: {
      default: false,
      type: Boolean,
    },
    settings: {
      type: Object,
      required: true,
    },
  },
  emits: [
    'update:settings',
  ],
  data() {
    this.locales = __;

    return {
      form: {
        selectedPaperSize: { id: this.settings.paperSize, label: __('export_setting_size_full') },
        selectedOrientation: this.settings.orientation,
      },
    };
  },
  computed: {
    paperSizeOptions() {
      return [
        { id: 'full', label: __('export_setting_size_full') },
        { id: 'Letter', label: __('export_setting_size_letter') },
        { id: 'Legal', label: __('export_setting_size_legal') },
        { id: 'Tabloid', label: __('export_setting_size_tabloid') },
        { id: 'Ledger', label: __('export_setting_size_ledger') },
        { id: 'A4', label: __('export_setting_size_a4') },
        { id: 'A3', label: __('export_setting_size_a3') },
        { id: 'A2', label: __('export_setting_size_a2') },
        { id: 'A1', label: __('export_setting_size_a1') },
        { id: 'A0', label: __('export_setting_size_a0') },
      ];
    },
  },
  methods: {
    handleSelectPaperSize(selected) {
      this.form.selectedPaperSize = selected[0];
      this.emitFormChange();
    },
    handleChangeOrientation(orientation) {
      this.form.selectedOrientation = orientation;
      this.emitFormChange();
    },
    emitFormChange() {
      this.$emit('update:settings', { paperSize: this.form.selectedPaperSize.id, orientation: this.form.selectedOrientation });
    },
  },
};
</script>

<style module lang="less">

.field {
  display: flex;
  flex-direction: column;
    margin: 0 12px 12px;

  &_label {
  font-size: 12px;
  line-height: 18px; /* 150% */
  color: #999999;
  font-family: "Lato-Bold", sans-serif;
  margin-bottom: 4px;
  }
}

.radio_group {
  display: flex;

  &_item {
    width: 138px;
    text-transform: capitalize;
  }
}

</style>
